import { render, staticRenderFns } from "./ModelInfo.vue?vue&type=template&id=067c1eb5&"
import script from "./ModelInfo.vue?vue&type=script&lang=js&"
export * from "./ModelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports